export default "__VITE_ASSET__D7rKhXn8__"